/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAggregatedMetricsList {
    getFixupPrototypeFunction() { return ResponseForAggregatedMetricsList.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAggregatedMetricsList>): ResponseForAggregatedMetricsList {
        let obj = Object.assign(new ResponseForAggregatedMetricsList(), model);
        ResponseForAggregatedMetricsList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAggregatedMetricsList>): ResponseForAggregatedMetricsList {
        if (!model) return null;
        return ResponseForAggregatedMetricsList.newInstance(<ResponseForAggregatedMetricsList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAggregatedMetricsList) {
        if (!obj) return;

        models.ResponseForAggregatedMetricsList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAggregatedMetricsList): boolean {
        Object.setPrototypeOf(obj, ResponseForAggregatedMetricsList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metrics) {
            for (let val of this.metrics) {
                models.AggregatedMetricsResponse.fixupPrototype(val);
            }
        }
    }

    /**
     * List of cost metrics
     */
    metrics: Array<models.AggregatedMetricsResponse>;

}
